export enum NAVBAR_TAB_NAMES {
    brnd_shop,
    brnd_brands,
    brnd_startup_incubator,
    brnd_courses,
    brnd_ideas,
    brnd_about,
    brands,

    genres,
    authors,
    publishingHouse,
    coursesContinium,

    all_competitions,
    about_competition,
    competitions,
    competitionsForContinuum,
    awards_portfolio,
    awards,
    awards_booksgallery,
    animation_awards,
    partners,
    residents,
    experts,

    hsecolors_main,
    hsecolors_catalog,
    hsecolors_community,
    hsecolors_education,

    am_school_about,
    am_school_communication,
    am_school_incoming,
    am_school_portfolio,
    am_school_news,

    hse_online_projects,
    hse_online_ba,
    hse_online_ma,
    hse_online_about,
    hse_online_join,
    hse_online_media,
    commdesign_program_page,

    custom_courses,
    all_courses,
    my_courses,
    schedule,
    homework,
    grades,
    project_module_name,

    onlines_portfolio,
    onlines_communication,
    onlines_school,
    onlines_library,

    shop_disabled,
    shop_deziiign,
    shop_galllery_art,
    shop_local,
    shop_gallllery,

    themes,
    competencies,
    tags,

    cgrave_competitions,
    cgrave_conference,
    cgrave_jury,

    portfolio_catalog,
    portfolio_portfolio,
    portfolio_tags,
    portfolio_competitions,
    portfolio_about,

    kiiids_catalog,
    kiiids_my_collection,
    kiiids_tags,
    kiiids_print,
    kiiids_events,
    kiiids_competitions,
    kiiids_about,

    lpu_awards,

    about,
    anchor_links,

    studio,
    studios,

    my_books,
    portfolio,
    portfolio_deziiign_external,
    courses,
    courses_lms,
    courses_lmshse,
    courses_offline,
    courses_online,
    names,
    artists,
    people,
    professors,
    special_projects,
    special_projects_main,
    publishers,
    longreads,
    laboratory,
    fantasy_sport,
    timeline,
    gallllery,
    e_books,
    wallet,
    fund,
    festival,
    map,
    create_place,
    create_project_hse,
    sound_deziiign,
    sound_lab,
    about_school,
    made_on_media,
    about_ifcid,
    students,
    education,
    coordinationCouncil,
    partnerUniversities,
    news,
    countries,
    institutions,
    
    calendar,
    sport_sports,
    sport_teams,
    sport_leagues,
    sport_ratings,

    about_the_project,
    tracks_and_nominations,
    results_of_previous_years,
    jury_page,

    adcr_awards,
    club_members,
    agencies_and_studios,
    winners,

    units,
    presentation,
    awardsHseSpace,
    coursesHseSpace,

    categories,

    artpublishing,
    subscription,
    lms,
    club,

    metrics,
    
    professions,
    community,
    books_gallllery,
    calendars,
    bookshops,
    sellers,
    deziiignresidents,
    concept,
    vacancies,
    courses_lab,
    main_courses,
    hsetto,
    studios_deziiign,
    diplomas,
    about_hse_start,
    creative_exam,
    admission_preparation,
    opportunities,
    news_hse_start,
    category_start_hse,
    russiangallllery,
    awards_start
}export enum NAVBAR_TAB_NAMES {
    brnd_shop,
    brnd_brands,
    brnd_startup_incubator,
    brnd_courses,
    brnd_ideas,
    brnd_about,
    brands,

    genres,
    authors,
    publishingHouse,
    coursesContinium,

    all_competitions,
    about_competition,
    competitions,
    competitionsForContinuum,
    awards_portfolio,
    awards,
    awards_booksgallery,
    animation_awards,
    partners,
    residents,
    experts,

    hsecolors_main,
    hsecolors_catalog,
    hsecolors_community,
    hsecolors_education,

    am_school_about,
    am_school_communication,
    am_school_incoming,
    am_school_portfolio,
    am_school_news,

    hse_online_projects,
    hse_online_ba,
    hse_online_ma,
    hse_online_about,
    hse_online_join,
    hse_online_media,
    commdesign_program_page,

    custom_courses,
    all_courses,
    my_courses,
    schedule,
    homework,
    grades,
    project_module_name,

    onlines_portfolio,
    onlines_communication,
    onlines_school,
    onlines_library,

    shop_disabled,
    shop_deziiign,
    shop_galllery_art,
    shop_local,
    shop_gallllery,

    themes,
    competencies,
    tags,

    cgrave_competitions,
    cgrave_conference,
    cgrave_jury,

    portfolio_catalog,
    portfolio_portfolio,
    portfolio_tags,
    portfolio_competitions,
    portfolio_about,

    kiiids_catalog,
    kiiids_my_collection,
    kiiids_tags,
    kiiids_print,
    kiiids_events,
    kiiids_competitions,
    kiiids_about,

    lpu_awards,

    about,
    anchor_links,

    studio,
    studios,

    my_books,
    portfolio,
    portfolio_deziiign_external,
    courses,
    courses_lms,
    courses_lmshse,
    courses_offline,
    courses_online,
    names,
    artists,
    people,
    professors,
    special_projects,
    special_projects_main,
    publishers,
    longreads,
    laboratory,
    fantasy_sport,
    timeline,
    gallllery,
    e_books,
    wallet,
    fund,
    festival,
    map,
    create_place,
    create_project_hse,
    sound_deziiign,
    sound_lab,
    about_school,
    made_on_media,
    about_ifcid,
    students,
    education,
    coordinationCouncil,
    partnerUniversities,
    news,
    countries,
    institutions,
    
    calendar,
    sport_sports,
    sport_teams,
    sport_leagues,
    sport_ratings,

    about_the_project,
    tracks_and_nominations,
    results_of_previous_years,
    jury_page,

    adcr_awards,
    club_members,
    agencies_and_studios,
    winners,

    units,
    presentation,
    awardsHseSpace,
    coursesHseSpace,

    categories,

    artpublishing,
    subscription,
    lms,
    club,

    metrics,
    
    professions,
    community,
    books_gallllery,
    calendars,
    bookshops,
    sellers,
    deziiignresidents,
    concept,
    vacancies,
    courses_lab,
    main_courses,
    hsetto,
    studios_deziiign,
    diplomas,
    about_hse_start,
    creative_exam,
    admission_preparation,
    opportunities,
    news_hse_start,
    category_start_hse,
    russiangallllery,
    awards_start
}